import React from "react";
import "./Dashboard.css";
import Button from "./Button";
import MultiButton from "./MultiButton";
import Loading from "./Util/Loading";
import { getStudents } from "./fetch";
import PieChart from "./PieChart";
import ScoreScaleBarBasic from "./ScoreScaleBarBasic";
import ScoreScaleBarBasicPercentage from "./ScoreScaleBarBasicPercentage";
import { iso3166Alpha2Countries } from "./data";
import { findElement } from "./helpers";
import { getUserGroups } from "./helpers";
import { getSettings } from "./fetch";
import moment from "moment";
import RadioButton from "./RadioButton";
import Window from "./Window";
import { Link, Route } from "react-router-dom";
import { getStudentsByFilter } from "./fetch";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: {},
      filter: {
        grades: "All",
      },
      students: [],
      validGrades: [],
      currentSy: "",
      nextSy: "",
      titleCurSy: "",
      titleNexSy: "",
      expandedNationalities: false,
      studentsForPopup: [],
      ealTotalsStudents: [],
      popupIsActive: false,
      mousePos: { x: 0, y: 0 },
    };

    this.getValidGrades = this.getValidGrades.bind(this);
    this.setCurrentSy = this.setCurrentSy.bind(this);
    this.handleGradeChange = this.handleGradeChange.bind(this);
    this.toggleExpandNationalities = this.toggleExpandNationalities.bind(this);
    this.handleOnFilterClick = this.handleOnFilterClick.bind(this);

    this.ealTotalsStudents = [];
    this.ealTotalsNyStudents = [];

    this.ealProfLevelsStudents = [];
    this.ealProfLevelsNyStudents = [];

    this.lrcTotalsStudents = [];
    this.lrcTotalsNyStudents = [];

    this.lrcRtiTiersStudents = [];
    this.lrcRtiTiersNyStudents = [];
  }

  _onMouseMove(e) {
    this.setState({ mousePos: { x: e.clientX, y: e.clientY } });
  }

  handleOnOuterClick(e) {
    this.setState({
      popupIsActive: false,
      studentsForPopup: [],
    });
  }

  handleOnFilterClick(filter) {
    let self = this;
    //console.log(data);
    this.setState((prevState) => ({
      popupIsActive: !prevState.popupIsActive,
      studentsForPopup: [],
    }));
    //console.log(filter);

    var filter = filter.split(",").map(function (item) {
      return item.trim();
    });

    var grade = filter[2].split(":").map(function (item) {
      return item.trim();
    });
    //console.log(filter[4]);
    //console.log(grade[1]);
    //console.log(this.ealTotalsStudents);
    switch (filter[4]) {
      case "ealTotalsStudents: Collaborative":
        self.setState({
          studentsForPopup: this.ealTotalsStudents[grade[1]].collaborative,
        });
        break;
      case "ealTotalsStudents: Comprehensive":
        self.setState({
          studentsForPopup: this.ealTotalsStudents[grade[1]].comprehensive,
        });
        break;
      case "ealTotalsStudents: Monitor 1":
        self.setState({
          studentsForPopup: this.ealTotalsStudents[grade[1]].monitor1,
        });
        break;
      case "ealTotalsStudents: Monitor 2":
        self.setState({
          studentsForPopup: this.ealTotalsStudents[grade[1]].monitor2,
        });
        break;
      case "ealTotalsStudents: Monitor 3":
        self.setState({
          studentsForPopup: this.ealTotalsStudents[grade[1]].monitor3,
        });
        break;
      case "ealProfLevelsStudents: 1":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l1,
        });
        break;
      case "ealProfLevelsStudents: 2":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l2,
        });
        break;
      case "ealProfLevelsStudents: 3":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l3,
        });
        break;
      case "ealProfLevelsStudents: 4":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l4,
        });
        break;
      case "ealProfLevelsStudents: 5":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l5,
        });
        break;
      case "ealProfLevelsStudents: 6":
        self.setState({
          studentsForPopup: this.ealProfLevelsStudents[grade[1]].l6,
        });
        break;
      case "lrcTotalsStudents: Collaborative":
        self.setState({
          studentsForPopup: this.lrcTotalsStudents[grade[1]].collaborative,
        });
        break;
      case "lrcTotalsStudents: Comprehensive":
        self.setState({
          studentsForPopup: this.lrcTotalsStudents[grade[1]].comprehensive,
        });
        break;
      case "lrcTotalsStudents: Monitor 1":
        self.setState({
          studentsForPopup: this.lrcTotalsStudents[grade[1]].monitor1,
        });
        break;
      case "lrcTotalsStudents: Monitor 2":
        self.setState({
          studentsForPopup: this.lrcTotalsStudents[grade[1]].monitor2,
        });
        break;
      case "lrcTotalsStudents: Monitor 3":
        self.setState({
          studentsForPopup: this.lrcTotalsStudents[grade[1]].monitor3,
        });
        break;
      case "lrcRtiTiersStudents: Tier 1":
        self.setState({
          studentsForPopup: this.lrcRtiTiersStudents[grade[1]].t1,
        });
        break;
      case "lrcRtiTiersStudents: Tier 2":
        self.setState({
          studentsForPopup: this.lrcRtiTiersStudents[grade[1]].t2,
        });
        break;
      case "lrcRtiTiersStudents: Tier 3":
        self.setState({
          studentsForPopup: this.lrcRtiTiersStudents[grade[1]].t3,
        });
        break;

      case "ealTotalsNyStudents: Collaborative":
        self.setState({
          studentsForPopup: this.ealTotalsNyStudents[grade[1]].collaborative,
        });
        break;
      case "ealTotalsNyStudents: Comprehensive":
        self.setState({
          studentsForPopup: this.ealTotalsNyStudents[grade[1]].comprehensive,
        });
        break;
      case "ealTotalsNyStudents: Monitor 1":
        self.setState({
          studentsForPopup: this.ealTotalsNyStudents[grade[1]].monitor1,
        });
        break;
      case "ealTotalsNyStudents: Monitor 2":
        self.setState({
          studentsForPopup: this.ealTotalsNyStudents[grade[1]].monitor2,
        });
        break;
      case "ealTotalsNyStudents: Monitor 3":
        self.setState({
          studentsForPopup: this.ealTotalsNyStudents[grade[1]].monitor3,
        });
        break;
      case "ealProfLevelsNyStudents: 1":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l1,
        });
        break;
      case "ealProfLevelsNyStudents: 2":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l2,
        });
        break;
      case "ealProfLevelsNyStudents: 3":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l3,
        });
        break;
      case "ealProfLevelsNyStudents: 4":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l4,
        });
        break;
      case "ealProfLevelsNyStudents: 5":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l5,
        });
        break;
      case "ealProfLevelsNyStudents: 6":
        self.setState({
          studentsForPopup: this.ealProfLevelsNyStudents[grade[1]].l6,
        });
        break;
      case "lrcTotalsNyStudents: Collaborative":
        self.setState({
          studentsForPopup: this.lrcTotalsNyStudents[grade[1]].collaborative,
        });
        break;
      case "lrcTotalsNyStudents: Comprehensive":
        self.setState({
          studentsForPopup: this.lrcTotalsNyStudents[grade[1]].comprehensive,
        });
        break;
      case "lrcTotalsNyStudents: Monitor 1":
        self.setState({
          studentsForPopup: this.lrcTotalsNyStudents[grade[1]].monitor1,
        });
        break;
      case "lrcTotalsNyStudents: Monitor 2":
        self.setState({
          studentsForPopup: this.lrcTotalsNyStudents[grade[1]].monitor2,
        });
        break;
      case "lrcTotalsNyStudents: Monitor 3":
        self.setState({
          studentsForPopup: this.lrcTotalsNyStudents[grade[1]].monitor3,
        });
        break;
      case "lrcRtiTiersNyStudents: Tier 1":
        self.setState({
          studentsForPopup: this.lrcRtiTiersNyStudents[grade[1]].t1,
        });
        break;
      case "lrcRtiTiersNyStudents: Tier 2":
        self.setState({
          studentsForPopup: this.lrcRtiTiersNyStudents[grade[1]].t2,
        });
        break;
      case "lrcRtiTiersNyStudents: Tier 3":
        self.setState({
          studentsForPopup: this.lrcRtiTiersNyStudents[grade[1]].t3,
        });
        break;

      default:
        self.setState({
          popupIsActive: false,
          studentsForPopup: [],
        });
        break;
    }

    // return getStudentsByFilter(filter)
    //   .then(response => {
    //     self.setState({
    //       studentsForPopup: response.data.studentsByFilter,
    //     });
    //   });
  }

  toggleExpandNationalities() {
    this.setState((prevState) => ({
      expandedNationalities: !prevState.expandedNationalities,
    }));
  }

  setCurrentSy() {
    const today = moment();
    const nextY = moment().add(1, "years");
    //const today = moment().subtract(1, 'year');
    //const today = moment(this.state.timeTravelDate); // temp for time travel
    //console.log(today.format('YYYY-MM-DD'));
    // console.log(nextY.format('YYYY-MM-DD'));
    this.setState({ currentSy: null, nextSy: null });
    this.state.settings.schoolYears.map((sy) => {
      //console.log(sy);
      if (today > moment(sy.startDate) && today < moment(sy.endDate)) {
        this.setState({
          currentSy: sy._id,
          titleCurSy: sy.title,
        });
      }
      if (nextY > moment(sy.startDate) && nextY < moment(sy.endDate)) {
        this.setState({
          nextSy: sy._id,
          titleNexSy: sy.title,
        });
      }
    });
    // console.log(this.state.titleCurSy);
    // console.log(this.state.titleNexSy);
  }

  getValidGrades() {
    var students = this.state.students;
    var flags = [],
      validGrades = [],
      l = students && students.length,
      i;
    for (i = 0; i < l; i++) {
      if (flags[students[i].currentGrade]) continue;
      flags[students[i].currentGrade] = true;
      validGrades.push(students[i].currentGrade);
    }
    return validGrades;
  }

  handleGradeChange(grade) {
    const GRADE = grade.target.getAttribute("data-specific");
    this.setState({
      filter: {
        grades: GRADE,
      },
    });
  }

  componentDidMount() {
    this.setState({ windowHeight: window.innerHeight });
    getSettings()
      .then((response) => {
        this.setState({
          settings: response.data,
        });
        window.localStorage.setItem("settings", JSON.stringify(response.data));
      })
      .then(() => {
        this.setCurrentSy();
      })
      .then((response) => {
        return getStudents("dash", this.state.currentSy);
      })
      .then((response) => {
        this.setState((prevState) => ({
          ...prevState,
          students: response.data.students,
        }));
      })
      .then(() => {
        this.setState((prevState) => ({
          ...prevState,
          validGrades: this.getValidGrades(),
        }));
      });
  }
  

  render() {
    const { x, y } = this.state.mousePos;

    const students = this.state.students;
    var validGrades = this.state.validGrades;
    var grades = validGrades;
    var filteredGrades = this.state.filter.grades;
    var filteredStudents = "";
    var self = this;

    if (this.state.filter.grades !== "All") {
      filteredStudents =
        students &&
        students.filter(function (student) {
          return (
            student.currentGrade === self.state.filter.grades &&
            student.inactive === false
          );
        });
    } else {
      filteredStudents =
        students &&
        students.filter(function (student) {
          return student.inactive === false;
        });
    }

    var numberOfStudents = filteredStudents ? filteredStudents.length : "...";

    // EAL Type of Support
    var ealTotals = {};
    var ealTotalsStudents = {};
    validGrades.map(function (grade, i) {
      ealTotals[grade] = {
        comprehensive: 0,
        collaborative: 0,
        monitor1: 0,
        monitor2: 0,
        monitor3: 0,
        monitor: 0,
        any: 0,
      };
      ealTotalsStudents[grade] = {
        comprehensive: [],
        collaborative: [],
        monitor1: [],
        monitor2: [],
        monitor3: [],
        monitor: [],
        any: [],
      };
    });
    ealTotals["All"] = {
      comprehensive: 0,
      collaborative: 0,
      monitor1: 0,
      monitor2: 0,
      monitor3: 0,
      monitor: 0,
      any: 0,
    };
    ealTotalsStudents["All"] = {
      comprehensive: [],
      collaborative: [],
      monitor1: [],
      monitor2: [],
      monitor3: [],
      monitor: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        var currentSyEals = [];

        var eoyEal = false;
        var moyEal = false;
        var boyEal = false;

        filteredStudents[i].eals &&
          filteredStudents[i].eals.map(function (eal) {
            if (eal.sy._id === self.state.currentSy) {
              currentSyEals.push(eal);
            }
          });

        var mostRecentEal = false;
        currentSyEals.map((csyEal) => {
          if (csyEal.termName === "EoY") {
            eoyEal = csyEal;
          }
          if (csyEal.termName === "MoY") {
            moyEal = csyEal;
          }
          if (csyEal.termName === "BoY") {
            boyEal = csyEal;
          }
        });

        mostRecentEal = eoyEal || moyEal || boyEal || false;

        if (mostRecentEal) {
          ealTotals[filteredStudents[i].currentGrade].any++;
          ealTotals["All"].any++;
          ealTotalsStudents[filteredStudents[i].currentGrade].any.push(
            filteredStudents[i]
          );
          ealTotalsStudents["All"].any.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Comprehensive") {
          ealTotals[filteredStudents[i].currentGrade].comprehensive++;
          ealTotals["All"].comprehensive++;
          ealTotalsStudents[
            filteredStudents[i].currentGrade
          ].comprehensive.push(filteredStudents[i]);
          ealTotalsStudents["All"].comprehensive.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Collaborative") {
          ealTotals[filteredStudents[i].currentGrade].collaborative++;
          ealTotals["All"].collaborative++;
          ealTotalsStudents[
            filteredStudents[i].currentGrade
          ].collaborative.push(filteredStudents[i]);
          ealTotalsStudents["All"].collaborative.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 1") {
          ealTotals[filteredStudents[i].currentGrade].monitor1++;
          ealTotals["All"].monitor1++;
          ealTotalsStudents[filteredStudents[i].currentGrade].monitor1.push(
            filteredStudents[i]
          );
          ealTotalsStudents["All"].monitor1.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 2") {
          ealTotals[filteredStudents[i].currentGrade].monitor2++;
          ealTotals["All"].monitor2++;
          ealTotalsStudents[filteredStudents[i].currentGrade].monitor2.push(
            filteredStudents[i]
          );
          ealTotalsStudents["All"].monitor2.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 3") {
          ealTotals[filteredStudents[i].currentGrade].monitor3++;
          ealTotals["All"].monitor3++;
          ealTotalsStudents[filteredStudents[i].currentGrade].monitor3.push(
            filteredStudents[i]
          );
          ealTotalsStudents["All"].monitor3.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor") {
          ealTotals[filteredStudents[i].currentGrade].monitor++;
          ealTotals["All"].monitor++;
          ealTotalsStudents[filteredStudents[i].currentGrade].monitor.push(
            filteredStudents[i]
          );
          ealTotalsStudents["All"].monitor.push(filteredStudents[i]);
        }
        currentSyEals = [];
      }
    }
    this.ealTotalsStudents = ealTotalsStudents;

    // console.log(ealTotalsStudents);
    // console.log(filteredStudents);

    // EAL Type of Support Next Year
    var ealTotalsNy = {};
    var ealTotalsNyStudents = {};
    validGrades.map(function (grade, i) {
      ealTotalsNy[grade] = {
        comprehensive: 0,
        collaborative: 0,
        monitor1: 0,
        monitor2: 0,
        monitor3: 0,
        monitor: 0,
        any: 0,
      };
      ealTotalsNyStudents[grade] = {
        comprehensive: [],
        collaborative: [],
        monitor1: [],
        monitor2: [],
        monitor3: [],
        monitor: [],
        any: [],
      };
    });
    ealTotalsNy["All"] = {
      comprehensive: 0,
      collaborative: 0,
      monitor1: 0,
      monitor2: 0,
      monitor3: 0,
      monitor: 0,
      any: 0,
    };
    ealTotalsNyStudents["All"] = {
      comprehensive: [],
      collaborative: [],
      monitor1: [],
      monitor2: [],
      monitor3: [],
      monitor: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        var currentSyEals = [];

        var eoyEal = false;
        var moyEal = false;
        var boyEal = false;

        filteredStudents[i].eals &&
          filteredStudents[i].eals.map(function (eal) {
            if (eal.sy._id === self.state.nextSy) {
              currentSyEals.push(eal);
            }
          });

        var mostRecentEal = false;
        currentSyEals.map((csyEal) => {
          if (csyEal.termName === "EoY") {
            eoyEal = csyEal;
          }
          if (csyEal.termName === "MoY") {
            moyEal = csyEal;
          }
          if (csyEal.termName === "BoY") {
            boyEal = csyEal;
          }
        });

        mostRecentEal = eoyEal || moyEal || boyEal || false;

        if (mostRecentEal) {
          ealTotalsNy[filteredStudents[i].currentGrade].any++;
          ealTotalsNy["All"].any++;
          ealTotalsNyStudents[filteredStudents[i].currentGrade].any.push(
            filteredStudents[i]
          );
          ealTotalsNyStudents["All"].any.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Comprehensive") {
          ealTotalsNy[filteredStudents[i].currentGrade].comprehensive++;
          ealTotalsNy["All"].comprehensive++;
          ealTotalsNyStudents[
            filteredStudents[i].currentGrade
          ].comprehensive.push(filteredStudents[i]);
          ealTotalsNyStudents["All"].comprehensive.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Collaborative") {
          ealTotalsNy[filteredStudents[i].currentGrade].collaborative++;
          ealTotalsNy["All"].collaborative++;
          ealTotalsNyStudents[
            filteredStudents[i].currentGrade
          ].collaborative.push(filteredStudents[i]);
          ealTotalsNyStudents["All"].collaborative.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 1") {
          ealTotalsNy[filteredStudents[i].currentGrade].monitor1++;
          ealTotalsNy["All"].monitor1++;
          ealTotalsNyStudents[filteredStudents[i].currentGrade].monitor1.push(
            filteredStudents[i]
          );
          ealTotalsNyStudents["All"].monitor1.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 2") {
          ealTotalsNy[filteredStudents[i].currentGrade].monitor2++;
          ealTotalsNy["All"].monitor2++;
          ealTotalsNyStudents[filteredStudents[i].currentGrade].monitor2.push(
            filteredStudents[i]
          );
          ealTotalsNyStudents["All"].monitor2.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor 3") {
          ealTotalsNy[filteredStudents[i].currentGrade].monitor3++;
          ealTotalsNy["All"].monitor3++;
          ealTotalsNyStudents[filteredStudents[i].currentGrade].monitor3.push(
            filteredStudents[i]
          );
          ealTotalsNyStudents["All"].monitor3.push(filteredStudents[i]);
        }
        if (mostRecentEal.typeOfSupport === "Monitor") {
          ealTotalsNy[filteredStudents[i].currentGrade].monitor++;
          ealTotalsNy["All"].monitor++;
          ealTotalsNyStudents[filteredStudents[i].currentGrade].monitor.push(
            filteredStudents[i]
          );
          ealTotalsNyStudents["All"].monitor.push(filteredStudents[i]);
        }
        currentSyEals = [];
      }
    }
    this.ealTotalsNyStudents = ealTotalsNyStudents;

    // EAL Prof Levels
    var ealProfLevels = {};
    var ealProfLevelsStudents = {};
    validGrades.map(function (grade, i) {
      ealProfLevels[grade] = {
        l1: 0,
        l2: 0,
        l3: 0,
        l4: 0,
        l5: 0,
        l6: 0,
        any: 0,
      };
      ealProfLevelsStudents[grade] = {
        l1: [],
        l2: [],
        l3: [],
        l4: [],
        l5: [],
        l6: [],
        any: [],
      };
    });
    ealProfLevels["All"] = {
      l1: 0,
      l2: 0,
      l3: 0,
      l4: 0,
      l5: 0,
      l6: 0,
      any: 0,
    };
    ealProfLevelsStudents["All"] = {
      l1: [],
      l2: [],
      l3: [],
      l4: [],
      l5: [],
      l6: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        var currentSyProfLevels = [];

        var eoyProfLevel = false;
        var moyProfLevel = false;
        var boyProfLevel = false;

        filteredStudents[i].eals &&
          filteredStudents[i].eals.map(function (eal) {
            if (eal.sy._id === self.state.currentSy) {
              currentSyProfLevels.push(eal);
            }
          });

        var mostRecentProfLevel = false;
        currentSyProfLevels.map((csyProfLevel) => {
          if (csyProfLevel.termName === "EoY") {
            eoyProfLevel = csyProfLevel;
          }
          if (csyProfLevel.termName === "MoY") {
            moyProfLevel = csyProfLevel;
          }
          if (csyProfLevel.termName === "BoY") {
            boyProfLevel = csyProfLevel;
          }
        });

        mostRecentProfLevel =
          eoyProfLevel || moyProfLevel || boyProfLevel || false;

        if (mostRecentProfLevel) {
          ealProfLevels[filteredStudents[i].currentGrade].any++;
          ealProfLevels["All"].any++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].any.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].any.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "1") {
          ealProfLevels[filteredStudents[i].currentGrade].l1++;
          ealProfLevels["All"].l1++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l1.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l1.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "2") {
          ealProfLevels[filteredStudents[i].currentGrade].l2++;
          ealProfLevels["All"].l2++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l2.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l2.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "3") {
          ealProfLevels[filteredStudents[i].currentGrade].l3++;
          ealProfLevels["All"].l3++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l3.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l3.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "4") {
          ealProfLevels[filteredStudents[i].currentGrade].l4++;
          ealProfLevels["All"].l4++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l4.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l4.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "5") {
          ealProfLevels[filteredStudents[i].currentGrade].l5++;
          ealProfLevels["All"].l5++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l5.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l5.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "6") {
          ealProfLevels[filteredStudents[i].currentGrade].l6++;
          ealProfLevels["All"].l6++;
          ealProfLevelsStudents[filteredStudents[i].currentGrade].l6.push(
            filteredStudents[i]
          );
          ealProfLevelsStudents["All"].l6.push(filteredStudents[i]);
        }
        currentSyProfLevels = [];
      }
    }
    this.ealProfLevelsStudents = ealProfLevelsStudents;

    // EAL Prof Levels Next Year
    var ealProfLevelsNy = {};
    var ealProfLevelsNyStudents = {};
    validGrades.map(function (grade, i) {
      ealProfLevelsNy[grade] = {
        l1: 0,
        l2: 0,
        l3: 0,
        l4: 0,
        l5: 0,
        l6: 0,
        any: 0,
      };
      ealProfLevelsNyStudents[grade] = {
        l1: [],
        l2: [],
        l3: [],
        l4: [],
        l5: [],
        l6: [],
        any: [],
      };
    });
    ealProfLevelsNy["All"] = {
      l1: 0,
      l2: 0,
      l3: 0,
      l4: 0,
      l5: 0,
      l6: 0,
      any: 0,
    };
    ealProfLevelsNyStudents["All"] = {
      l1: [],
      l2: [],
      l3: [],
      l4: [],
      l5: [],
      l6: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        var currentSyProfLevels = [];

        var eoyProfLevel = false;
        var moyProfLevel = false;
        var boyProfLevel = false;

        filteredStudents[i].eals &&
          filteredStudents[i].eals.map(function (eal) {
            if (eal.sy._id === self.state.nextSy) {
              currentSyProfLevels.push(eal);
            }
          });

        var mostRecentProfLevel = false;
        currentSyProfLevels.map((csyProfLevel) => {
          if (csyProfLevel.termName === "EoY") {
            eoyProfLevel = csyProfLevel;
          }
          if (csyProfLevel.termName === "MoY") {
            moyProfLevel = csyProfLevel;
          }
          if (csyProfLevel.termName === "BoY") {
            boyProfLevel = csyProfLevel;
          }
        });

        mostRecentProfLevel =
          eoyProfLevel || moyProfLevel || boyProfLevel || false;

        if (mostRecentProfLevel) {
          ealProfLevelsNy[filteredStudents[i].currentGrade].any++;
          ealProfLevelsNy["All"].any++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].any.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].any.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "1") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l1++;
          ealProfLevelsNy["All"].l1++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l1.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l1.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "2") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l2++;
          ealProfLevelsNy["All"].l2++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l2.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l2.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "3") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l3++;
          ealProfLevelsNy["All"].l3++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l3.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l3.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "4") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l4++;
          ealProfLevelsNy["All"].l4++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l4.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l4.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "5") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l5++;
          ealProfLevelsNy["All"].l5++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l5.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l5.push(filteredStudents[i]);
        }
        if (mostRecentProfLevel.profLevel === "6") {
          ealProfLevelsNy[filteredStudents[i].currentGrade].l6++;
          ealProfLevelsNy["All"].l6++;
          ealProfLevelsNyStudents[filteredStudents[i].currentGrade].l6.push(
            filteredStudents[i]
          );
          ealProfLevelsNyStudents["All"].l6.push(filteredStudents[i]);
        }
        currentSyProfLevels = [];
      }
    }
    this.ealProfLevelsNyStudents = ealProfLevelsNyStudents;

    // LRC Type of Support
    var lrcTotals = {};
    var lrcTotalsStudents = {};
    validGrades.map(function (grade, i) {
      lrcTotals[grade] = {
        comprehensive: 0,
        collaborative: 0,
        monitor1: 0,
        monitor2: 0,
        monitor3: 0,
        individualAccommodationsPlan: 0,
        individualLearningPlan: 0,
        any: 0,
      };
      lrcTotalsStudents[grade] = {
        comprehensive: [],
        collaborative: [],
        monitor1: [],
        monitor2: [],
        monitor3: [],
        individualAccommodationsPlan: [],
        individualLearningPlan: [],
        any: [],
      };
    });
    lrcTotals["All"] = {
      comprehensive: 0,
      collaborative: 0,
      monitor1: 0,
      monitor2: 0,
      monitor3: 0,
      individualAccommodationsPlan: 0,
      individualLearningPlan: 0,
      any: 0,
    };
    lrcTotalsStudents["All"] = {
      comprehensive: [],
      collaborative: [],
      monitor1: [],
      monitor2: [],
      monitor3: [],
      individualAccommodationsPlan: [],
      individualLearningPlan: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        filteredStudents[i].lrcs &&
          filteredStudents[i].lrcs.map(function (lrc) {
            if (lrc.sy._id === self.state.currentSy) {
              lrcTotals[filteredStudents[i].currentGrade].any++;
              lrcTotals["All"].any++;
              lrcTotalsStudents[filteredStudents[i].currentGrade].any.push(
                filteredStudents[i]
              );
              lrcTotalsStudents["All"].any.push(filteredStudents[i]);

              if (lrc.modeOfSupport === "Comprehensive") {
                lrcTotals[filteredStudents[i].currentGrade].comprehensive++;
                lrcTotals["All"].comprehensive++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].comprehensive.push(filteredStudents[i]);
                lrcTotalsStudents["All"].comprehensive.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Collaborative") {
                lrcTotals[filteredStudents[i].currentGrade].collaborative++;
                lrcTotals["All"].collaborative++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].collaborative.push(filteredStudents[i]);
                lrcTotalsStudents["All"].collaborative.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Monitor 1") {
                lrcTotals[filteredStudents[i].currentGrade].monitor1++;
                lrcTotals["All"].monitor1++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].monitor1.push(filteredStudents[i]);
                lrcTotalsStudents["All"].monitor1.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Monitor 2") {
                lrcTotals[filteredStudents[i].currentGrade].monitor2++;
                lrcTotals["All"].monitor2++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].monitor2.push(filteredStudents[i]);
                lrcTotalsStudents["All"].monitor2.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Monitor 3") {
                lrcTotals[filteredStudents[i].currentGrade].monitor3++;
                lrcTotals["All"].monitor3++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].monitor3.push(filteredStudents[i]);
                lrcTotalsStudents["All"].monitor3.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Individual Accommodations Plan") {
                lrcTotals[filteredStudents[i].currentGrade]
                  .individualAccommodationsPlan++;
                lrcTotals["All"].individualAccommodationsPlan++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].individualAccommodationsPlan.push(filteredStudents[i]);
                lrcTotalsStudents["All"].individualAccommodationsPlan.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Individual Learning Plan") {
                lrcTotals[filteredStudents[i].currentGrade]
                  .individualLearningPlan++;
                lrcTotals["All"].individualLearningPlan++;
                lrcTotalsStudents[
                  filteredStudents[i].currentGrade
                ].individualLearningPlan.push(filteredStudents[i]);
                lrcTotalsStudents["All"].individualLearningPlan.push(
                  filteredStudents[i]
                );
              }
            }
          });
      }
    }
    this.lrcTotalsStudents = lrcTotalsStudents;

    // LRC Type of Support Next Year
    var lrcTotalsNy = {};
    var lrcTotalsNyStudents = {};
    validGrades.map(function (grade, i) {
      lrcTotalsNy[grade] = {
        comprehensive: 0,
        collaborative: 0,
        monitor1: 0,
        monitor2: 0,
        monitor3: 0,
        individualAccommodationsPlan: 0,
        individualLearningPlan: 0,
        any: 0,
      };
      lrcTotalsNyStudents[grade] = {
        comprehensive: [],
        collaborative: [],
        monitor1: [],
        monitor2: [],
        monitor3: [],
        individualAccommodationsPlan: [],
        individualLearningPlan: [],
        any: [],
      };
    });
    lrcTotalsNy["All"] = {
      comprehensive: 0,
      collaborative: 0,
      monitor1: 0,
      monitor2: 0,
      monitor3: 0,
      individualAccommodationsPlan: 0,
      individualLearningPlan: 0,
      any: 0,
    };
    lrcTotalsNyStudents["All"] = {
      comprehensive: [],
      collaborative: [],
      monitor1: [],
      monitor2: [],
      monitor3: [],
      individualAccommodationsPlan: [],
      individualLearningPlan: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        filteredStudents[i].lrcs &&
          filteredStudents[i].lrcs.map(function (lrc) {
            if (lrc.sy._id === self.state.nextSy) {
              lrcTotalsNy[filteredStudents[i].currentGrade].any++;
              lrcTotalsNy["All"].any++;
              lrcTotalsNyStudents[filteredStudents[i].currentGrade].any.push(
                filteredStudents[i]
              );
              lrcTotalsNyStudents["All"].any.push(filteredStudents[i]);

              if (lrc.modeOfSupport === "Comprehensive") {
                lrcTotalsNy[filteredStudents[i].currentGrade].comprehensive++;
                lrcTotalsNy["All"].comprehensive++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].comprehensive.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].comprehensive.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Collaborative") {
                lrcTotalsNy[filteredStudents[i].currentGrade].collaborative++;
                lrcTotalsNy["All"].collaborative++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].collaborative.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].collaborative.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Monitor 1") {
                lrcTotalsNy[filteredStudents[i].currentGrade].monitor1++;
                lrcTotalsNy["All"].monitor1++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].monitor1.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].monitor1.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Monitor 2") {
                lrcTotalsNy[filteredStudents[i].currentGrade].monitor2++;
                lrcTotalsNy["All"].monitor2++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].monitor2.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].monitor2.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Monitor 3") {
                lrcTotalsNy[filteredStudents[i].currentGrade].monitor3++;
                lrcTotalsNy["All"].monitor3++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].monitor3.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].monitor3.push(filteredStudents[i]);
              }
              if (lrc.modeOfSupport === "Individual Accommodations Plan") {
                lrcTotalsNy[filteredStudents[i].currentGrade]
                  .individualAccommodationsPlan++;
                lrcTotalsNy["All"].individualAccommodationsPlan++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].individualAccommodationsPlan.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].individualAccommodationsPlan.push(
                  filteredStudents[i]
                );
              }
              if (lrc.modeOfSupport === "Individual Learning Plan") {
                lrcTotalsNy[filteredStudents[i].currentGrade]
                  .individualLearningPlan++;
                lrcTotalsNy["All"].individualLearningPlan++;
                lrcTotalsNyStudents[
                  filteredStudents[i].currentGrade
                ].individualLearningPlan.push(filteredStudents[i]);
                lrcTotalsNyStudents["All"].individualLearningPlan.push(
                  filteredStudents[i]
                );
              }
            }
          });
      }
    }
    this.lrcTotalsNyStudents = lrcTotalsNyStudents;

    // LRC RTI Tiers
    var lrcRtiTiers = {};
    var lrcRtiTiersStudents = {};
    validGrades.map(function (grade, i) {
      lrcRtiTiers[grade] = {
        t1: 0,
        t2: 0,
        t3: 0,
        any: 0,
      };
      lrcRtiTiersStudents[grade] = {
        t1: [],
        t2: [],
        t3: [],
        any: [],
      };
    });
    lrcRtiTiers["All"] = {
      t1: 0,
      t2: 0,
      t3: 0,
      any: 0,
    };
    lrcRtiTiersStudents["All"] = {
      t1: [],
      t2: [],
      t3: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        filteredStudents[i].lrcs &&
          filteredStudents[i].lrcs.map(function (lrc) {
            if (lrc.sy._id === self.state.currentSy) {
              lrcRtiTiers[filteredStudents[i].currentGrade].any++;
              lrcRtiTiers["All"].any++;
              lrcRtiTiersStudents[filteredStudents[i].currentGrade].any.push(
                filteredStudents[i]
              );
              lrcRtiTiersStudents["All"].any.push(filteredStudents[i]);
              if (lrc.rtiTier === "Tier 1") {
                lrcRtiTiers[filteredStudents[i].currentGrade].t1++;
                lrcRtiTiers["All"].t1++;
                lrcRtiTiersStudents[filteredStudents[i].currentGrade].t1.push(
                  filteredStudents[i]
                );
                lrcRtiTiersStudents["All"].t1.push(filteredStudents[i]);
              }
              if (lrc.rtiTier === "Tier 2") {
                lrcRtiTiers[filteredStudents[i].currentGrade].t2++;
                lrcRtiTiers["All"].t2++;
                lrcRtiTiersStudents[filteredStudents[i].currentGrade].t2.push(
                  filteredStudents[i]
                );
                lrcRtiTiersStudents["All"].t2.push(filteredStudents[i]);
              }
              if (lrc.rtiTier === "Tier 3") {
                lrcRtiTiers[filteredStudents[i].currentGrade].t3++;
                lrcRtiTiers["All"].t3++;
                lrcRtiTiersStudents[filteredStudents[i].currentGrade].t3.push(
                  filteredStudents[i]
                );
                lrcRtiTiersStudents["All"].t3.push(filteredStudents[i]);
              }
            }
          });
      }
    }
    this.lrcRtiTiersStudents = lrcRtiTiersStudents;

    // LRC RTI Tiers Next Year
    var lrcRtiTiersNy = {};
    var lrcRtiTiersNyStudents = {};
    validGrades.map(function (grade, i) {
      lrcRtiTiersNy[grade] = {
        t1: 0,
        t2: 0,
        t3: 0,
        any: 0,
      };
      lrcRtiTiersNyStudents[grade] = {
        t1: [],
        t2: [],
        t3: [],
        any: [],
      };
    });
    lrcRtiTiersNy["All"] = {
      t1: 0,
      t2: 0,
      t3: 0,
      any: 0,
    };
    lrcRtiTiersNyStudents["All"] = {
      t1: [],
      t2: [],
      t3: [],
      any: [],
    };
    if (validGrades.length > 0) {
      for (var i = 0; i < (filteredStudents && filteredStudents.length); i++) {
        filteredStudents[i].lrcs &&
          filteredStudents[i].lrcs.map(function (lrc) {
            if (lrc.sy._id === self.state.nextSy) {
              lrcRtiTiersNy[filteredStudents[i].currentGrade].any++;
              lrcRtiTiersNy["All"].any++;
              lrcRtiTiersNyStudents[filteredStudents[i].currentGrade].any.push(
                filteredStudents[i]
              );
              lrcRtiTiersNyStudents["All"].any.push(filteredStudents[i]);
              if (lrc.rtiTier === "Tier 1") {
                lrcRtiTiersNy[filteredStudents[i].currentGrade].t1++;
                lrcRtiTiersNy["All"].t1++;
                lrcRtiTiersNyStudents[filteredStudents[i].currentGrade].t1.push(
                  filteredStudents[i]
                );
                lrcRtiTiersNyStudents["All"].t1.push(filteredStudents[i]);
              }
              if (lrc.rtiTier === "Tier 2") {
                lrcRtiTiersNy[filteredStudents[i].currentGrade].t2++;
                lrcRtiTiersNy["All"].t2++;
                lrcRtiTiersNyStudents[filteredStudents[i].currentGrade].t2.push(
                  filteredStudents[i]
                );
                lrcRtiTiersNyStudents["All"].t2.push(filteredStudents[i]);
              }
              if (lrc.rtiTier === "Tier 3") {
                lrcRtiTiersNy[filteredStudents[i].currentGrade].t3++;
                lrcRtiTiersNy["All"].t3++;
                lrcRtiTiersNyStudents[filteredStudents[i].currentGrade].t3.push(
                  filteredStudents[i]
                );
                lrcRtiTiersNyStudents["All"].t3.push(filteredStudents[i]);
              }
            }
          });
      }
    }
    this.lrcRtiTiersNyStudents = lrcRtiTiersNyStudents;

    //console.log(lrcRtiTiers);

    // Citizenship
    /*
    var flags = [], citizenships = [], i;
    for (i = 0; i < students.length; i++) {
        if (flags[students[i].primaryCitizenship]) continue;
        flags[students[i].primaryCitizenship] = true;
        citizenships.push(students[i].primaryCitizenship);
    }
    console.log('for', citizenships);
    */

    // or like this
    // this is for primary citizenship only
    /*
    var countries = iso3166Alpha2Countries;
    var citizenships = [...new Set(filteredStudents.map(item => item.primaryCitizenship))];

    var citiBreakdown = [];
    citizenships.map(function(citizenship) {
      itiBreakdown.push({code: citizenship, num: 0});
    });

    filteredStudents.map(function(student) {
      citizenships.map(function(citizenship) {
        if (student.primaryCitizenship === citizenship) {
          citiBreakdown.map(function(citi) {
            if (citi.code === citizenship) {
              citi.num++;
            }
          });
        }
      });
    });

    citiBreakdown.sort(function(a, b){
      return b.num - a.num;
    });
    */

    // this is for all citizenships (some students have multi citizenship)
    var countries = iso3166Alpha2Countries;
    var allCitizenships = [];
    var citiBreakdown = [];

    filteredStudents.map(function (student) {
      student.citizenship.split(",").map((c) => {
        c = c.trim();
        c = c.replace("*", "");
        allCitizenships.push(c);
      });
    });
    //console.log('allCitizenships', allCitizenships);
    //console.log(countries, 'countries');

    allCitizenships.map((c, i) => {
      countries.map((country) => {
        switch (c) {
          case "Korea":
            c = "Korea, Republic Of";
            break;
          //case 'Russia': c = 'Russian Federation'; break;
          case "Democratic People's Republic of":
            c = "Korea, Democratic People's Republic Of";
            break;
          case "Macedonia":
            c = "North Macedonia";
            break;
          case "Kazakhstan":
            c = "Kazakstan";
            break;
          case "Palestine":
            c = "Palestinian Territory, Occupied";
            break;
          case "Iran":
            c = "Iran, Islamic Republic Of";
            break;
          case "Vietnam":
            c = "Viet Nam";
            break;
          case "Taiwan":
            c = "Taiwan, Province Of China";
            break;
          case "Bosnia and Herzegovina":
            c = "Bosnia And Herzegovina";
            break;
          case "Singaporean":
            c = "Singapore";
            break;
          case "Greece":
            c = "Greek";
            break;
          default:
            c = c;
        }
        if (country.name === c) {
          allCitizenships[i] = country.code;
        }
      });
    });

    var differentCitizenships = [
      ...new Set(allCitizenships.map((item) => item)),
    ];

    differentCitizenships.map(function (citizenship) {
      citiBreakdown.push({ code: citizenship, num: 0 });
    });

    allCitizenships.map((c) => {
      citiBreakdown.map(function (citi) {
        if (citi.code === c) {
          citi.num++;
        }
      });
    });

    citiBreakdown.sort(function (a, b) {
      return b.num - a.num;
    });

    //console.log("citi", citiBreakdown);
    //console.log(grades, "grade");
    // console.log("STudents",this.state.students);  ==>Empty
    // console.log();

    return (
      <div>
        <div
          className="Dashboard"
          onMouseMove={
            !this.state.popupIsActive && this._onMouseMove.bind(this)
          }
        >
          <div className="grid__row MultiRadioButtonWrapper">
            <div className="grid__col col--100">
              <p>Grade</p>
            </div>
            <div className="grid__col">
              <MultiButton className="MultiButton">
                <RadioButton
                  key="All"
                  handleClick={this.handleGradeChange}
                  data="All"
                  title="All"
                  active={this.state.filter.grades === "All"}
                />
                {grades.map((grade) => (
                  <RadioButton
                    key={grade}
                    handleClick={this.handleGradeChange}
                    data={grade}
                    title={
                      grade.substring(0, 3) === "Gra"
                        ? grade.substr(6)
                        : grade === "Kindergarten"
                        ? "K"
                        : grade === "Multiage 3"
                        ? "MA3"
                        : "MA4"
                    }
                    active={this.state.filter.grades === grade}
                  />
                ))}
              </MultiButton>
            </div>
          </div>

          {this.state.students.length > 0 ? (
            <div>
              <div
                className="dash-item__container"
                style={{ marginTop: "2rem" }}
              >
                <div className="dash-item dash-item--number dash-item--number-of-students">
                  <h3 className="dash-item__heading">
                    Total Number
                    <br />
                    of Students
                  </h3>
                  <div className="big-number">{numberOfStudents}</div>
                </div>

                <div className="dash-item dash-nationalities">
                  <div className="dash-nationalities-header">
                    <h3 className="dash-item__heading">
                      Top Nationalities{" "}
                      <span style={{ fontWeight: "normal", fontSize: "1rem" }}>
                        ({citiBreakdown.length} Different Nationalities)
                      </span>
                    </h3>
                  </div>

                  <div className="top-3">
                    {citiBreakdown.map(function (citi, i) {
                      if (i < 3) {
                        return (
                          // Top secondary nationalities
                          <div key={i} className="table__row">
                            <div className="table__cell top-number">
                              {i + 1}
                            </div>
                            {/* Flag */}
                            <div className="table__cell">
                              <span className="f32">
                                <img src={"/countries/" + citi.code + ".jpg"} width="25" height="18" />
                              </span>
                            </div>
                            <div className="table__cell">
                              {/* {countries.find((o) => o.code === citi.code).name ? countries.find((o) => o.code === citi.code).name : ""} */}
                              {countries.find((o) => o.code === citi.code).name === "Czech Republic" ? "Czechia" : countries.find((o) => o.code === citi.code).name}
                              {/* {console.log(countries.find((o) => o.code === citi.code).name)} */}
                            </div>
                            <div className="table__cell">
                              <strong>{citi.num}</strong>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>

                  <div className="nationalities-list">
                    {citiBreakdown.map(function (citi, j) {
                      //if (j > 2 && j < 23 || j > 2 && self.state.expandedNationalities) {
                      if (j > 2 && j < 19) {
                        return (
                          // Top primary nationalities
                          <div key={citi.code} className="table__row">
                            <div className="table__cell top-number">
                              {j + 1}
                            </div>
                            {/* Flag */}
                            <div className="table__cell">
                              <span className="f16">
                                <img src={"/countries/" + citi.code + ".jpg"} width="25" height="18" />
                              </span>
                            </div>
                            <div className="table__cell">
                              {/* {countries.find((o) => o.code === citi.code).name ? countries.find((o) => o.code === citi.code).name : ""} */}
                              {countries.find((o) => o.code === citi.code).name === "Czech Republic" ? "Czechia" : countries.find((o) => o.code === citi.code).name}
                              {/* {console.log(countries.find((o) => o.code === citi.code).name)} */}
                            </div>
                            <div className="table__cell">
                              <strong>{citi.num}</strong>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>

                  <Link to="/dashboard/nationalities" className="show-all-link">
                    Show All
                  </Link>

                  <Route
                    path={"/dashboard/nationalities/"}
                    render={({ history, match }) => (
                      <Window
                        history={history}
                        title={
                          self.state.filter.grades != "All"
                            ? "Nationalities Breakdown (" +
                              self.state.filter.grades +
                              ")"
                            : "Nationalities Breakdown"
                        }
                        close={true}
                      >
                        <div className="all-nationalities-list"> 
                          {citiBreakdown.map(function (citi, j) {
                            return (
                              <div key={citi.code} className="table__row">
                                <div className="table__cell top-number">
                                  {j + 1}
                                </div>
                                <div className="table__cell">
                                  <span className="f16">
                                    {/* <span
                                      className={
                                        "flag " + citi.code.toLowerCase()
                                      }
                                    ></span> */}
                                    {/* COnstruction here */}
                                    <img src={"/countries/" + citi.code + ".jpg"} width="25" height="18" />
                                  </span>
                                </div>
                                <div className="table__cell">
                                  {/* {countries.find((o) => o.code === citi.code).name ? countries.find((o) => o.code === citi.code).name : ""} */}
                                  {countries.find((o) => o.code === citi.code).name == "Czech Republic" ? "Czechia" : countries.find((o) => o.code === citi.code).name}

                                </div>
                                <div className="table__cell">
                                  <strong>{citi.num}</strong>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Window>
                    )}
                  />

                  {/*
                  <div className="top-3">
                    {citiBreakdown.map(function(citi, i) {
                      if (i < 3) {
                        return (
                          <div key={i} className="table__row">
                            <div className="table__cell top-number">{i + 1}</div>
                            <div className="table__cell">
                              <span className="f32">
                                <span className={"flag " + citi.code.toLowerCase()}></span>
                              </span>
                            </div>
                            <div className="table__cell">
                              {countries.find(o => o.code === citi.code).name ? countries.find(o => o.code === citi.code).name : ""}
                            </div>
                            <div className="table__cell">
                              <strong>{citi.num}</strong>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                  */}

                  {/*[0,1,2,3].map(function(i) {
                    return (
                      <div key={i} className="column">
                        {citiBreakdown.map(function(citi, j) {
                          if (j >= (i * 5 + 3) && j < ((i + 1) * 5 + 3)) {
                            return (
                              <div key={citi.code} className="table__row">
                                <div className="table__cell top-number">{j + 1}</div>
                                <div className="table__cell">
                                  <span className="f16">
                                    <span className={"flag " + citi.code.toLowerCase()}></span>
                                  </span>
                                </div>
                                <div className="table__cell">
                                  {findElement(countries, 'code', citi.code).name}
                                </div>
                                <div className="table__cell">
                                  <strong>{citi.num}</strong>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    )
                  })*/}
                </div>
              </div>

              <div className="dash-item__container">
                <div className="dash-item dash-item--number">
                  <h3 className="dash-item__heading">
                    EAL Students<small> - ({self.state.titleCurSy})</small>
                  </h3>
                  <PieChart
                    width={90}
                    height={90}
                    x={45}
                    y={45}
                    data={[
                      ealTotals[filteredGrades].any,
                      numberOfStudents - ealTotals[filteredGrades].any,
                    ]}
                    radius={40}
                    innerRadius={1}
                    labels={["EAL", ""]}
                    showLegend={false}
                    showTotal={false}
                    kindOfLabelsOnSlices="labels"
                    showLabelsOnSlices={false}
                    fill={["#81a7ef", "#d9d9d9"]}
                    handleOnClick={self.handleOnFilterClick}
                    onClickFilter={[
                      `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}`,
                      null,
                    ]}
                  />
                  <div className="big-number">
                    {ealTotals[filteredGrades].any}
                  </div>
                  <div>
                    {(
                      (ealTotals[filteredGrades].any / numberOfStudents) *
                      100
                    ).toFixed(1)}{" "}
                    %
                  </div>
                </div>

                <div className="dash-item">
                  <h3 className="dash-item__heading">
                    EAL Proficiency Levels
                    <small> - ({self.state.titleCurSy})</small>
                  </h3>

                  {ealProfLevels[filteredGrades].any > 0 ? (
                    <div>
                      {ealProfLevels[filteredGrades].any > 0 ? (
                        <PieChart
                          width={400}
                          height={250}
                          radius={95}
                          x={100}
                          fillType="range"
                          fill={["#c4d6f7", "#81a7ef"]}
                          onClickFilter={[
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 1, ealProfLevelsStudents: 1`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 2, ealProfLevelsStudents: 2`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 3, ealProfLevelsStudents: 3`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 4, ealProfLevelsStudents: 4`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 5, ealProfLevelsStudents: 5`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.profLevel: 6, ealProfLevelsStudents: 6`,
                          ]}
                          handleOnClick={self.handleOnFilterClick}
                          data={[
                            ealProfLevels[filteredGrades].l1,
                            ealProfLevels[filteredGrades].l2,
                            ealProfLevels[filteredGrades].l3,
                            ealProfLevels[filteredGrades].l4,
                            ealProfLevels[filteredGrades].l5,
                            ealProfLevels[filteredGrades].l6,
                          ]}
                          labels={[
                            "Level 1" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l1 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l1 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Level 2" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l2 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l2 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Level 3" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l3 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l3 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Level 4" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l4 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l4 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Level 5" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l5 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l5 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Level 6" +
                              "$" +
                              (
                                (ealProfLevels[filteredGrades].l6 /
                                  ealProfLevels[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealProfLevels[filteredGrades].l6 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                          ]}
                        />
                      ) : (
                        <PieChart
                          width={400}
                          height={150}
                          data={null}
                          labels={[
                            "Level 1" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].comprehensive /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            "Collaborative" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].collaborative /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            // 'Monitor 1' + ' ' + Math.round((ealTotals[filteredGrades].monitor1 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 2' + ' ' + Math.round((ealTotals[filteredGrades].monitor2 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 3' + ' ' + Math.round((ealTotals[filteredGrades].monitor3 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            "Monitor" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].monitor /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                          ]}
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <p>No EAL Students</p>
                      <PieChart
                        width={400}
                        height={150}
                        data={null}
                        labels={[
                          "Monitor" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].monitor /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Comprehensive" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].comprehensive /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Collaborative" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].collaborative /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                        ]}
                      />
                    </div>
                  )}
                </div>
                <div className="dash-item">
                  <h3 className="dash-item__heading">
                    EAL Type of Support
                    <small> - ({self.state.titleCurSy})</small>
                  </h3>

                  {ealTotals[filteredGrades].any > 0 ? (
                    <div>
                      {ealTotals[filteredGrades].any > 0 ? (
                        <PieChart
                          width={400}
                          height={200}
                          fillType="specific"
                          fill={[
                            "#87cbed",
                            "#64bbe8",
                            "#f390b8",
                            "#ef6ba0",
                            "#ec4688",
                          ]}
                          handleOnClick={self.handleOnFilterClick}
                          onClickFilter={[
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.typeOfSupport: Comprehensive, ealTotalsStudents: Comprehensive`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.typeOfSupport: Collaborative, ealTotalsStudents: Collaborative`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.typeOfSupport: Monitor 1, ealTotalsStudents: Monitor 1`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.typeOfSupport: Monitor 2, ealTotalsStudents: Monitor 2`,
                            `inactive: false, eals.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, eals.1.typeOfSupport: Monitor 3, ealTotalsStudents: Monitor 3`,
                          ]}
                          data={[
                            ealTotals[filteredGrades].comprehensive,
                            ealTotals[filteredGrades].collaborative,
                            // ealTotals[filteredGrades].monitor1,
                            // ealTotals[filteredGrades].monitor2,
                            // ealTotals[filteredGrades].monitor3,
                            ealTotals[filteredGrades].monitor,
                          ]}
                          labels={[
                            "Comprehensive" +
                              "$" +
                              (
                                (ealTotals[filteredGrades].comprehensive /
                                  ealTotals[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealTotals[filteredGrades].comprehensive /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Collaborative" +
                              "$" +
                              (
                                (ealTotals[filteredGrades].collaborative /
                                  ealTotals[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealTotals[filteredGrades].collaborative /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            // 'Monitor 1' + '$' + (ealTotals[filteredGrades].monitor1 / (ealTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotals[filteredGrades].monitor1 / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Monitor 2' + '$' + (ealTotals[filteredGrades].monitor2 / (ealTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotals[filteredGrades].monitor2 / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Monitor 3' + '$' + (ealTotals[filteredGrades].monitor3 / (ealTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotals[filteredGrades].monitor3 / numberOfStudents * 100).toFixed(1) + " %",
                            "Monitor" +
                              "$" +
                              (
                                (ealTotals[filteredGrades].monitor /
                                  ealTotals[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (ealTotals[filteredGrades].monitor /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                          ]}
                        />
                      ) : (
                        <PieChart
                          width={400}
                          height={150}
                          data={null}
                          labels={[
                            "Comprehensive" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].comprehensive /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            "Collaborative" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].collaborative /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            // 'Monitor 1' + ' ' + Math.round((ealTotals[filteredGrades].monitor1 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 2' + ' ' + Math.round((ealTotals[filteredGrades].monitor2 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 3' + ' ' + Math.round((ealTotals[filteredGrades].monitor3 / (ealTotals[filteredGrades].any) * 100), 5) + " %",
                            "Monitor" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].monitor /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                          ]}
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <p>No EAL Students</p>
                      <PieChart
                        width={400}
                        height={150}
                        data={null}
                        labels={[
                          "Monitor" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].monitor /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Comprehensive" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].comprehensive /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Collaborative" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].collaborative /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                        ]}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="dash-item__container">
                <div className="dash-item dash-item--number">
                  <h3 className="dash-item__heading">
                    LSS Students<small> - ({self.state.titleCurSy})</small>
                  </h3>
                  <PieChart
                    width={90}
                    height={90}
                    x={45}
                    y={45}
                    data={[
                      lrcRtiTiers[filteredGrades].any,
                      numberOfStudents - lrcRtiTiers[filteredGrades].any,
                    ]}
                    radius={40}
                    innerRadius={1}
                    labels={["EAL", ""]}
                    showLegend={false}
                    showTotal={false}
                    kindOfLabelsOnSlices="labels"
                    showLabelsOnSlices={false}
                    fill={["#800080", "#d9d9d9"]}
                    handleOnClick={self.handleOnFilterClick}
                    onClickFilter={[
                      `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}`,
                      null,
                    ]}
                  />
                  <div className="big-number">
                    {lrcRtiTiers[filteredGrades].any}
                  </div>
                  <div>
                    {(
                      (lrcRtiTiers[filteredGrades].any / numberOfStudents) *
                      100
                    ).toFixed(1)}{" "}
                    %
                  </div>
                </div>

                <div className="dash-item">
                  <h3 className="dash-item__heading">
                    LSS RTI Tiers<small> - ({self.state.titleCurSy})</small>
                  </h3>

                  {lrcRtiTiers[filteredGrades].any > 0 ? (
                    <div>
                      {lrcRtiTiers[filteredGrades].any > 0 ? (
                        <PieChart
                          width={400}
                          height={200}
                          fillType="range"
                          fill={["#e600e5", "#800080"]}
                          data={[
                            lrcRtiTiers[filteredGrades].t1,
                            lrcRtiTiers[filteredGrades].t2,
                            lrcRtiTiers[filteredGrades].t3,
                          ]}
                          labels={[
                            "Tier 1" +
                              "$" +
                              (
                                (lrcRtiTiers[filteredGrades].t1 /
                                  lrcRtiTiers[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (lrcRtiTiers[filteredGrades].t1 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Tier 2" +
                              "$" +
                              (
                                (lrcRtiTiers[filteredGrades].t2 /
                                  lrcRtiTiers[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (lrcRtiTiers[filteredGrades].t2 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Tier 3" +
                              "$" +
                              (
                                (lrcRtiTiers[filteredGrades].t3 /
                                  lrcRtiTiers[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (lrcRtiTiers[filteredGrades].t3 /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                          ]}
                          handleOnClick={self.handleOnFilterClick}
                          onClickFilter={[
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.rtiTier: Tier 1, lrcRtiTiersStudents: Tier 1`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.rtiTier: Tier 2, lrcRtiTiersStudents: Tier 2`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.rtiTier: Tier 3, lrcRtiTiersStudents: Tier 3`,
                          ]}
                        />
                      ) : (
                        <PieChart
                          width={400}
                          height={150}
                          data={null}
                          labels={[
                            "Level 1" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].comprehensive /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            "Collaborative" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].collaborative /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            "Monitor 1" +
                              " " +
                              Math.round(
                                (ealTotals[filteredGrades].monitor1 /
                                  ealTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                          ]}
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <p>No LSS Students</p>
                      <PieChart
                        width={400}
                        height={150}
                        data={null}
                        labels={[
                          "Monitor" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].monitor /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Comprehensive" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].comprehensive /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Collaborative" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].collaborative /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                        ]}
                      />
                    </div>
                  )}
                </div>
                <div className="dash-item">
                  <h3 className="dash-item__heading">
                    LSS Type of Support
                    <small> - ({self.state.titleCurSy})</small>
                  </h3>

                  {lrcTotals[filteredGrades].any > 0 ? (
                    <div>
                      {lrcTotals[filteredGrades].any > 0 ? (
                        <PieChart
                          width={400}
                          height={200}
                          fillType="specific"
                          fill={[
                            "#87cbed",
                            "#64bbe8",
                            "#f390b8",
                            "#ef6ba0",
                            "#ec4688",
                          ]}
                          data={[
                            // lrcTotals[filteredGrades].comprehensive,
                            // lrcTotals[filteredGrades].collaborative,
                            // lrcTotals[filteredGrades].monitor1,
                            // lrcTotals[filteredGrades].monitor2,
                            // lrcTotals[filteredGrades].monitor3,
                            lrcTotals[filteredGrades]
                              .individualAccommodationsPlan,
                            lrcTotals[filteredGrades].individualLearningPlan,
                          ]}
                          labels={[
                            // 'Comprehensive' + '$' + (lrcTotals[filteredGrades].comprehensive / (lrcTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotals[filteredGrades].comprehensive / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Collaborative' + '$' + (lrcTotals[filteredGrades].collaborative / (lrcTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotals[filteredGrades].collaborative / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Monitor 1' + '$' + (lrcTotals[filteredGrades].monitor1 / (lrcTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotals[filteredGrades].monitor1 / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Monitor 2' + '$' + (lrcTotals[filteredGrades].monitor2 / (lrcTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotals[filteredGrades].monitor2 / numberOfStudents * 100).toFixed(1) + " %",
                            // 'Monitor 3' + '$' + (lrcTotals[filteredGrades].monitor3 / (lrcTotals[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotals[filteredGrades].monitor3 / numberOfStudents * 100).toFixed(1) + " %",
                            "Individual Accommodations Plan" +
                              "$" +
                              (
                                (lrcTotals[filteredGrades]
                                  .individualAccommodationsPlan /
                                  lrcTotals[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (lrcTotals[filteredGrades]
                                  .individualAccommodationsPlan /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                            "Individual Learning Plan" +
                              "$" +
                              (
                                (lrcTotals[filteredGrades]
                                  .individualLearningPlan /
                                  lrcTotals[filteredGrades].any) *
                                100
                              ).toFixed() +
                              " %" +
                              " / " +
                              (
                                (lrcTotals[filteredGrades]
                                  .individualLearningPlan /
                                  numberOfStudents) *
                                100
                              ).toFixed(1) +
                              " %",
                          ]}
                          handleOnClick={self.handleOnFilterClick}
                          onClickFilter={[
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.modeOfSupport: Comprehensive, lrcTotalsStudents: Comprehensive`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.modeOfSupport: Collaborative, lrcTotalsStudents: Collaborative`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.modeOfSupport: Monitor 1, lrcTotalsStudents: Monitor 1`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.modeOfSupport: Monitor 2, lrcTotalsStudents: Monitor 2`,
                            `inactive: false, lrcs.sy._id: ${self.state.currentSy}, currentGrade: ${self.state.filter.grades}, lrcs.1.modeOfSupport: Monitor 3, lrcTotalsStudents: Monitor 3`,
                          ]}
                        />
                      ) : (
                        <PieChart
                          width={400}
                          height={150}
                          data={null}
                          labels={[
                            "Comprehensive" +
                              " " +
                              Math.round(
                                (lrcTotals[filteredGrades].comprehensive /
                                  lrcTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            "Collaborative" +
                              " " +
                              Math.round(
                                (lrcTotals[filteredGrades].collaborative /
                                  lrcTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                            // 'Monitor 1' + ' ' + Math.round((lrcTotals[filteredGrades].monitor1 / (lrcTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 2' + ' ' + Math.round((lrcTotals[filteredGrades].monitor2 / (lrcTotals[filteredGrades].any) * 100), 5) + " %",
                            // 'Monitor 3' + ' ' + Math.round((lrcTotals[filteredGrades].monitor3 / (lrcTotals[filteredGrades].any) * 100), 5) + " %",
                            "Monitor" +
                              " " +
                              Math.round(
                                (lrcTotals[filteredGrades].monitor /
                                  lrcTotals[filteredGrades].any) *
                                  100,
                                5
                              ) +
                              " %",
                          ]}
                        />
                      )}
                    </div>
                  ) : (
                    <div>
                      <p>No LSS Students</p>
                      <PieChart
                        width={400}
                        height={150}
                        data={null}
                        labels={[
                          "Monitor" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].monitor /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Comprehensive" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].comprehensive /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                          "Collaborative" +
                            " " +
                            Math.round(
                              (ealTotals[filteredGrades].collaborative /
                                ealTotals[filteredGrades].any) *
                                100,
                              5
                            ) +
                            " %",
                        ]}
                      />
                    </div>
                  )}
                </div>
              </div>
              {/*Dashboard for Admission only*/}
              {(getUserGroups().includes("admin") ||
                getUserGroups().includes("admission")) && (
                <div>
                  <div className="dash-item__container">
                    <div className="dash-item dash-item--number">
                      <h3 className="dash-item__heading">
                        EAL Students<small> - ({self.state.titleNexSy})</small>
                      </h3>
                      <PieChart
                        width={90}
                        height={90}
                        x={45}
                        y={45}
                        data={[
                          ealTotalsNy[filteredGrades].any,
                          numberOfStudents - ealTotalsNy[filteredGrades].any,
                        ]}
                        radius={40}
                        innerRadius={1}
                        labels={["EAL", ""]}
                        showLegend={false}
                        showTotal={false}
                        kindOfLabelsOnSlices="labels"
                        showLabelsOnSlices={false}
                        fill={["#81a7ef", "#d9d9d9"]}
                        handleOnClick={self.handleOnFilterClick}
                        onClickFilter={[
                          `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}`,
                          null,
                        ]}
                      />
                      <div className="big-number">
                        {ealTotalsNy[filteredGrades].any}
                      </div>
                      <div>
                        {(
                          (ealTotalsNy[filteredGrades].any / numberOfStudents) *
                          100
                        ).toFixed(1)}{" "}
                        %
                      </div>
                    </div>

                    <div className="dash-item">
                      <h3 className="dash-item__heading">
                        EAL Proficiency Levels
                        <small> - ({self.state.titleNexSy})</small>
                      </h3>

                      {ealProfLevelsNy[filteredGrades].any > 0 ? (
                        <div>
                          {ealProfLevelsNy[filteredGrades].any > 0 ? (
                            <PieChart
                              width={400}
                              height={250}
                              radius={95}
                              x={100}
                              fillType="range"
                              fill={["#c4d6f7", "#81a7ef"]}
                              onClickFilter={[
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 1, ealProfLevelsNyStudents: 1`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 2, ealProfLevelsNyStudents: 2`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 3, ealProfLevelsNyStudents: 3`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 4, ealProfLevelsNyStudents: 4`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 5, ealProfLevelsNyStudents: 5`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.profLevel: 6, ealProfLevelsNyStudents: 6`,
                              ]}
                              handleOnClick={self.handleOnFilterClick}
                              data={[
                                ealProfLevelsNy[filteredGrades].l1,
                                ealProfLevelsNy[filteredGrades].l2,
                                ealProfLevelsNy[filteredGrades].l3,
                                ealProfLevelsNy[filteredGrades].l4,
                                ealProfLevelsNy[filteredGrades].l5,
                                ealProfLevelsNy[filteredGrades].l6,
                              ]}
                              labels={[
                                "Level 1" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l1 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l1 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Level 2" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l2 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l2 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Level 3" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l3 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l3 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Level 4" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l4 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l4 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Level 5" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l5 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l5 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Level 6" +
                                  "$" +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l6 /
                                      ealProfLevelsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealProfLevelsNy[filteredGrades].l6 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                              ]}
                            />
                          ) : (
                            <PieChart
                              width={400}
                              height={150}
                              data={null}
                              labels={[
                                "Level 1" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].comprehensive /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Collaborative" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].collaborative /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 1" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].monitor1 /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 2" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].monitor2 /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 3" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].monitor3 /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                              ]}
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          <p>No EAL Students</p>
                          <PieChart
                            width={400}
                            height={150}
                            data={null}
                            labels={[
                              "Monitor" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].monitor /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Comprehensive" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].comprehensive /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Collaborative" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].collaborative /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                            ]}
                          />
                        </div>
                      )}
                    </div>
                    <div className="dash-item">
                      <h3 className="dash-item__heading">
                        EAL Type of Support
                        <small> - ({self.state.titleNexSy})</small>
                      </h3>

                      {ealTotalsNy[filteredGrades].any > 0 ? (
                        <div>
                          {ealTotalsNy[filteredGrades].any > 0 ? (
                            <PieChart
                              width={400}
                              height={200}
                              fillType="specific"
                              fill={[
                                "#87cbed",
                                "#64bbe8",
                                "#f390b8",
                                "#ef6ba0",
                                "#ec4688",
                              ]}
                              handleOnClick={self.handleOnFilterClick}
                              onClickFilter={[
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.typeOfSupport: Comprehensive, ealTotalsNyStudents: Comprehensive`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.typeOfSupport: Collaborative, ealTotalsNyStudents: Collaborative`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.typeOfSupport: Monitor 1, ealTotalsNyStudents: Monitor 1`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.typeOfSupport: Monitor 2, ealTotalsNyStudents: Monitor 2`,
                                `inactive: false, eals.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, eals.0.typeOfSupport: Monitor 3, ealTotalsNyStudents: Monitor 3`,
                              ]}
                              data={[
                                ealTotalsNy[filteredGrades].comprehensive,
                                ealTotalsNy[filteredGrades].collaborative,
                                // ealTotalsNy[filteredGrades].monitor1,
                                // ealTotalsNy[filteredGrades].monitor2,
                                // ealTotalsNy[filteredGrades].monitor3,
                                ealTotalsNy[filteredGrades].monitor,
                              ]}
                              labels={[
                                "Comprehensive" +
                                  "$" +
                                  (
                                    (ealTotalsNy[filteredGrades].comprehensive /
                                      ealTotalsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealTotalsNy[filteredGrades].comprehensive /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Collaborative" +
                                  "$" +
                                  (
                                    (ealTotalsNy[filteredGrades].collaborative /
                                      ealTotalsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealTotalsNy[filteredGrades].collaborative /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                // 'Monitor 1' + '$' + (ealTotalsNy[filteredGrades].monitor1 / (ealTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotalsNy[filteredGrades].monitor1 / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Monitor 2' + '$' + (ealTotalsNy[filteredGrades].monitor2 / (ealTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotalsNy[filteredGrades].monitor2 / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Monitor 3' + '$' + (ealTotalsNy[filteredGrades].monitor3 / (ealTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (ealTotalsNy[filteredGrades].monitor3 / numberOfStudents * 100).toFixed(1) + " %",
                                "Monitor" +
                                  "$" +
                                  (
                                    (ealTotalsNy[filteredGrades].monitor /
                                      ealTotalsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (ealTotalsNy[filteredGrades].monitor /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                              ]}
                            />
                          ) : (
                            <PieChart
                              width={400}
                              height={150}
                              data={null}
                              labels={[
                                "Comprehensive" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].comprehensive /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Collaborative" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].collaborative /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                // 'Monitor 1' + ' ' + Math.round((ealTotalsNy[filteredGrades].monitor1 / (ealTotalsNy[filteredGrades].any) * 100), 5) + " %",
                                // 'Monitor 2' + ' ' + Math.round((ealTotalsNy[filteredGrades].monitor2 / (ealTotalsNy[filteredGrades].any) * 100), 5) + " %",
                                // 'Monitor 3' + ' ' + Math.round((ealTotalsNy[filteredGrades].monitor3 / (ealTotalsNy[filteredGrades].any) * 100), 5) + " %",
                                "Monitor" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].monitor /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                              ]}
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          <p>No EAL Students</p>
                          <PieChart
                            width={400}
                            height={150}
                            data={null}
                            labels={[
                              "Monitor" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].monitor /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Comprehensive" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].comprehensive /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Collaborative" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].collaborative /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                            ]}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="dash-item__container">
                    <div className="dash-item dash-item--number">
                      <h3 className="dash-item__heading">
                        LSS Students<small> - ({self.state.titleNexSy})</small>
                      </h3>
                      <PieChart
                        width={90}
                        height={90}
                        x={45}
                        y={45}
                        data={[
                          lrcRtiTiersNy[filteredGrades].any,
                          numberOfStudents - lrcRtiTiersNy[filteredGrades].any,
                        ]}
                        radius={40}
                        innerRadius={1}
                        labels={["EAL", ""]}
                        showLegend={false}
                        showTotal={false}
                        kindOfLabelsOnSlices="labels"
                        showLabelsOnSlices={false}
                        fill={["#800080", "#d9d9d9"]}
                        handleOnClick={self.handleOnFilterClick}
                        onClickFilter={[
                          `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}`,
                          null,
                        ]}
                      />
                      <div className="big-number">
                        {lrcRtiTiersNy[filteredGrades].any}
                      </div>
                      <div>
                        {(
                          (lrcRtiTiersNy[filteredGrades].any /
                            numberOfStudents) *
                          100
                        ).toFixed(1)}{" "}
                        %
                      </div>
                    </div>

                    <div className="dash-item">
                      <h3 className="dash-item__heading">
                        LSS RTI Tiers<small> - ({self.state.titleNexSy})</small>
                      </h3>

                      {lrcRtiTiersNy[filteredGrades].any > 0 ? (
                        <div>
                          {lrcRtiTiersNy[filteredGrades].any > 0 ? (
                            <PieChart
                              width={400}
                              height={200}
                              fillType="range"
                              fill={["#e600e5", "#800080"]}
                              data={[
                                lrcRtiTiersNy[filteredGrades].t1,
                                lrcRtiTiersNy[filteredGrades].t2,
                                lrcRtiTiersNy[filteredGrades].t3,
                              ]}
                              labels={[
                                "Tier 1" +
                                  "$" +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t1 /
                                      lrcRtiTiersNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t1 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Tier 2" +
                                  "$" +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t2 /
                                      lrcRtiTiersNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t2 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Tier 3" +
                                  "$" +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t3 /
                                      lrcRtiTiersNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (lrcRtiTiersNy[filteredGrades].t3 /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                              ]}
                              handleOnClick={self.handleOnFilterClick}
                              onClickFilter={[
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.rtiTier: Tier 1, lrcRtiTiersNyStudents: Tier 1`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.rtiTier: Tier 2, lrcRtiTiersNyStudents: Tier 2`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.rtiTier: Tier 3, lrcRtiTiersNyStudents: Tier 3`,
                              ]}
                            />
                          ) : (
                            <PieChart
                              width={400}
                              height={150}
                              data={null}
                              labels={[
                                "Level 1" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].comprehensive /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Collaborative" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].collaborative /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 1" +
                                  " " +
                                  Math.round(
                                    (ealTotalsNy[filteredGrades].monitor1 /
                                      ealTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                              ]}
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          <p>No LSS Students</p>
                          <PieChart
                            width={400}
                            height={150}
                            data={null}
                            labels={[
                              "Monitor" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].monitor /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Comprehensive" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].comprehensive /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Collaborative" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].collaborative /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                            ]}
                          />
                        </div>
                      )}
                    </div>
                    <div className="dash-item">
                      <h3 className="dash-item__heading">
                        LSS Type of Support
                        <small> - ({self.state.titleNexSy})</small>
                      </h3>

                      {lrcTotalsNy[filteredGrades].any > 0 ? (
                        <div>
                          {lrcTotalsNy[filteredGrades].any > 0 ? (
                            <PieChart
                              width={400}
                              height={200}
                              fillType="specific"
                              fill={[
                                "#87cbed",
                                "#64bbe8",
                                "#f390b8",
                                "#ef6ba0",
                                "#ec4688",
                              ]}
                              data={[
                                // lrcTotalsNy[filteredGrades].comprehensive,
                                // lrcTotalsNy[filteredGrades].collaborative,
                                // lrcTotalsNy[filteredGrades].monitor1,
                                // lrcTotalsNy[filteredGrades].monitor2,
                                // lrcTotalsNy[filteredGrades].monitor3,
                                lrcTotalsNy[filteredGrades]
                                  .individualAccommodationsPlan,
                                lrcTotalsNy[filteredGrades]
                                  .individualLearningPlan,
                              ]}
                              labels={[
                                // 'Comprehensive' + '$' + (lrcTotalsNy[filteredGrades].comprehensive / (lrcTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotalsNy[filteredGrades].comprehensive / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Collaborative' + '$' + (lrcTotalsNy[filteredGrades].collaborative / (lrcTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotalsNy[filteredGrades].collaborative / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Monitor 1' + '$' + (lrcTotalsNy[filteredGrades].monitor1 / (lrcTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotalsNy[filteredGrades].monitor1 / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Monitor 2' + '$' + (lrcTotalsNy[filteredGrades].monitor2 / (lrcTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotalsNy[filteredGrades].monitor2 / numberOfStudents * 100).toFixed(1) + " %",
                                // 'Monitor 3' + '$' + (lrcTotalsNy[filteredGrades].monitor3 / (lrcTotalsNy[filteredGrades].any) * 100).toFixed() + " %" + " / " + (lrcTotalsNy[filteredGrades].monitor3 / numberOfStudents * 100).toFixed(1) + " %",
                                "Individual Accommodations Plan" +
                                  "$" +
                                  (
                                    (lrcTotalsNy[filteredGrades]
                                      .individualAccommodationsPlan /
                                      lrcTotalsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (lrcTotalsNy[filteredGrades]
                                      .individualAccommodationsPlan /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                                "Individual Learning Plan" +
                                  "$" +
                                  (
                                    (lrcTotalsNy[filteredGrades]
                                      .individualLearningPlan /
                                      lrcTotalsNy[filteredGrades].any) *
                                    100
                                  ).toFixed() +
                                  " %" +
                                  " / " +
                                  (
                                    (lrcTotalsNy[filteredGrades]
                                      .individualLearningPlan /
                                      numberOfStudents) *
                                    100
                                  ).toFixed(1) +
                                  " %",
                              ]}
                              handleOnClick={self.handleOnFilterClick}
                              onClickFilter={[
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.modeOfSupport: Comprehensive, lrcTotalsNyStudents: Comprehensive`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.modeOfSupport: Collaborative, lrcTotalsNyStudents: Collaborative`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.modeOfSupport: Monitor 1, lrcTotalsNyStudents: Monitor 1`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.modeOfSupport: Monitor 2, lrcTotalsNyStudents: Monitor 2`,
                                `inactive: false, lrcs.sy._id: ${self.state.nextSy}, currentGrade: ${self.state.filter.grades}, lrcs.0.modeOfSupport: Monitor 3, lrcTotalsNyStudents: Monitor 3`,
                              ]}
                            />
                          ) : (
                            <PieChart
                              width={400}
                              height={150}
                              data={null}
                              labels={[
                                "Comprehensive" +
                                  " " +
                                  Math.round(
                                    (lrcTotalsNy[filteredGrades].comprehensive /
                                      lrcTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Collaborative" +
                                  " " +
                                  Math.round(
                                    (lrcTotalsNy[filteredGrades].collaborative /
                                      lrcTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 1" +
                                  " " +
                                  Math.round(
                                    (lrcTotalsNy[filteredGrades].monitor1 /
                                      lrcTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 2" +
                                  " " +
                                  Math.round(
                                    (lrcTotalsNy[filteredGrades].monitor2 /
                                      lrcTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                                "Monitor 3" +
                                  " " +
                                  Math.round(
                                    (lrcTotalsNy[filteredGrades].monitor3 /
                                      lrcTotalsNy[filteredGrades].any) *
                                      100,
                                    5
                                  ) +
                                  " %",
                              ]}
                            />
                          )}
                        </div>
                      ) : (
                        <div>
                          <p>No LSS Students</p>
                          <PieChart
                            width={400}
                            height={150}
                            data={null}
                            labels={[
                              "Monitor" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].monitor /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Comprehensive" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].comprehensive /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                              "Collaborative" +
                                " " +
                                Math.round(
                                  (ealTotalsNy[filteredGrades].collaborative /
                                    ealTotalsNy[filteredGrades].any) *
                                    100,
                                  5
                                ) +
                                " %",
                            ]}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {self.state.popupIsActive &&
                self.state.studentsForPopup &&
                self.state.studentsForPopup.length > 0 && (
                  <div
                    className="popup-overlay"
                    onClick={this.handleOnOuterClick.bind(this)}
                  >
                    <div
                      className="students-popup"
                      style={
                        y + 200 > self.state.windowHeight
                          ? { bottom: self.state.windowHeight - y, left: x }
                          : { top: y, left: x }
                      }
                    >
                      {self.state.studentsForPopup &&
                        self.state.studentsForPopup.length > 0 &&
                        self.state.studentsForPopup.map((s) => (
                          <p>
                            <Link
                              to={`/students/${s._id}/general`}
                            >{`${s.lastName}, ${s.firstName}`}</Link>
                          </p>
                        ))}
                    </div>
                  </div>
                )}
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Dashboard2.js